// Model.js
// -----------------------
// @module Case
define("SuiteDB.SDBQuoteImprovements.SDBQuoteImprovement.Model", [
  "Backbone",
  "SCModel",
  "Utils",
  "underscore",
  "Singleton",
], function (Backbone, SCModelComponent, Utils, _, Singleton) {
  "use strict";
  var SCModel = SCModelComponent.SCModel;

  function SDBQuoteImprovementModel() {
    SCModel.call(this);

    this.urlRoot = function () {
      return Utils.getAbsoluteUrl(
        getExtensionAssetsPath("services/SDBQuoteImprovement.Service.ss")
      );
    };
  }
  SDBQuoteImprovementModel.prototype = Object.create(SCModel.prototype);
  SDBQuoteImprovementModel.prototype.constructor = SDBQuoteImprovementModel;
  return _.extend(SDBQuoteImprovementModel, Singleton);
});
